import React from "react";
import Util from "../../util/util";
import Moment from "moment";
import Constants from "../../configurations/constants";

const ObjectToList = ({ items, index, className }) => {
  return (
    <div className={className}>
      {typeof items === "object" ? (
        Object.keys(items).map(key => (
          <div key={key + (index ? index : "")}>
            <label>{isNaN(key) ? Util.camelToSentence(key) : ""}: </label>
            <label>
              {items[key] && typeof items[key] !== "object" ? (
                items[key] === true ? (
                  "Yes"
                ) : items[key] === false ? (
                  "No"
                ) : Util.isValidDate(items[key].toString()) ? (
                  Moment(items[key].toString()).format(
                    Constants.DATE_FORMAT_LONG
                  )
                ) : (
                  items[key].toString()
                )
              ) : (
                <div className="sub-additional-info">
                  <RenderObjects objectToConv={items[key]} />
                </div>
              )}
            </label>
          </div>
        ))
      ) : (
        <li />
      )}
    </div>
  );
};

const RenderObjects = ({ objectToConv, className }) => {
  return (
    <div className="App">
      {objectToConv && typeof objectToConv === "object" ? (
        objectToConv.isArray && objectToConv.length ? (
          objectToConv.map((items, index) => (
            <ObjectToList
              key={index}
              className={className}
              items={items}
              index={index}
            />
          ))
        ) : (
          <ObjectToList className={className} items={objectToConv} />
        )
      ) : (
        <p>{objectToConv ? objectToConv.toString() : "---"}</p>
      )}
    </div>
  );
};

export default RenderObjects;



// WEBPACK FOOTER //
// ./src/components/common/ObjectRenderer.js